module.exports = __webpack_public_path__ + "static/media/hambalek_valkovic.cd074075.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/hambalek_valkovic.jpg
// module id = 488
// module chunks = 0